import moment from "moment";

export default function(Vue, options) {

  // // 将时间戳转化成特定日期格式
  // Vue.prototype.UnixToTime = function(unix) {
  //   return moment.unix(unix).format("YYYY-MM-DD HH:mm:ss");
  // }

}